import { yupResolver } from "@hookform/resolvers/yup"
import CloseIcon from "@mui/icons-material/Close"
import WarningAmberIcon from "@mui/icons-material/WarningAmber"
import { Box, Button, DialogTitle, IconButton, Typography, useTheme } from "@mui/material"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import TextField from "@mui/material/TextField"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import useMediaQuery from "@mui/material/useMediaQuery"
import { MuiFileInput } from "mui-file-input"
import React, { useContext, useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import * as yup from "yup"
import { enviarMasInformacionLicencia, ingresadas } from "../../Redux/licencias"
import TokenContext from "../../context/TokenContext"
import CustomTextField from "../CustomTextField"
import { cargarAdjuntoSolicitud } from "../../Redux/solicitudes"
import { UserAuth } from "../../context/AuthContext"

const ModalLicencias = ({ open, handleClose, licencia, adjuntarCertificado, requiereInformacion }) => {
  const dispatch = useDispatch()
  const theme = useTheme()
  const token = useContext(TokenContext)
  const { empleado } = UserAuth();

  const cargaDocumento = useSelector((store) => store.licencias.cargaDocumento)
  const loadEnviarMasInformacion = useSelector((store) => store.licencias.loadEnviarMasInformacion)
  const estadoCargaAdjunto = useSelector((store) => store.solicitudes.estadoCargaAdjunto)

  const [fullWidth, setFullWidth] = React.useState(true)
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))
  const [maxWidth, setMaxWidth] = React.useState("sm")

  const [selectedFiles, setSelectedFiles] = React.useState([])

  const defaultValues = {
    id: null,
    comentarios: null,
  }

  const validacionSchema = yup.object().shape({
    comentarios: yup.string().required("Los comentarios son requeridos"),
  })

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  })

  const { handleSubmit, reset } = methods

  useEffect(() => {
    reset(licencia)
  }, [licencia, reset])

  const changeHandler = (newFile) => {
    setSelectedFiles(newFile)
  }

  const submitDatos = (datos) => {
    dispatch(enviarMasInformacionLicencia(token, datos))
    .then((id) => {
      handleClose()
      dispatch(ingresadas(token, empleado.usuarioPortalRh))
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  }

  const enviarCertificado = () => {
    if (selectedFiles?.length === 0) {
      toast.error("El archivo adjunto es requerido!", {
        theme: "dark",
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
      return
    }
    const formData = new FormData()
    for (let index = 0; index < selectedFiles.length; index++) {
      if (selectedFiles[index].size >= 15000000) {
        toast.error("El archivo no puede superar los 15 megas", {
          theme: "dark",
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        setSelectedFiles([])
        return
      }
      let element = selectedFiles[index]
      formData.append(`body${index}`, element)
    }
    dispatch(cargarAdjuntoSolicitud(token, formData, licencia.id, 'licencia_id'))
    setSelectedFiles(null)
  }

  return (
    <Dialog fullWidth={fullWidth} maxWidth={maxWidth} open={open} onClose={handleClose}>
      <DialogTitle sx={{ m: 1, p: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <FormProvider {...methods}>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                readOnly={true}
                name="new_name"
                label="Tipo de Licencia"
                rules={{ required: "Required!" }}
                helperText="Por favor indica el tipo de Licencia."
                req={adjuntarCertificado}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                readOnly={true}
                name="empleado"
                label="Empleado"
                rules={{ required: "Required!" }}
                helperText="Por favor indica el Empleado."
                req={adjuntarCertificado}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                readOnly={true}
                type="number"
                name="diasSolicitados"
                label="Dias Solicitados"
                rules={{ required: "Required!" }}
                helperText="Por favor indica los dias solicitados."
                req={adjuntarCertificado}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                type="date"
                name="new_fechadesdeModal"
                label="Fecha desde:"
                readOnly
                rules={{ required: "Required!" }}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                type="date"
                name="new_fechahastaModal"
                label="Fecha hasta:"
                readOnly
                rules={{ required: "Required!" }}
              />
            </Grid>
            {requiereInformacion && (
              <>
                <Grid xs={12} md={12} item sx={{ pt: 0, pb: 0 }}>
                  <CustomTextField
                    Component={TextField}
                    type="text"
                    label="Comentarios"
                    name="comentarios"
                    multiline={true}
                    rows="4"
                  />
                </Grid>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    // sx={buttonSx}
                    disabled={loadEnviarMasInformacion === "LOADING" || estadoCargaAdjunto === "LOADING"}
                    onClick={handleSubmit(submitDatos)}
                  >
                    Enviar
                  </Button>
                </Grid>
              </>
            )}
          </FormProvider>
        </Grid>
        {adjuntarCertificado && (
          <>
            <Grid xs={12} md={12} item sx={{ pt: 0, pb: 0, mt: 2 }}>
              <MuiFileInput value={selectedFiles} multiple label="Adjuntar Certificado" onChange={changeHandler} fullWidth />
            </Grid>
            <Grid sx={{ px: 2, mb: 2, mt: 1 }}>
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Box sx={{ height: "100%" }}>
                  <WarningAmberIcon color="warning" sx={{ mr: 1 }} />
                </Box>
                <Box sx={{ height: "100%" }}>
                  <Typography>El tamaño máximo permitido por archivo es de 15 MB</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid xs={12} md={12} item sx={{ pt: 0, pb: 0 }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                // sx={buttonSx}
                disabled={cargaDocumento === "LOADING"}
                onClick={enviarCertificado}
              >
                Enviar certificado
              </Button>
            </Grid>
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default ModalLicencias
